module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Area":"Rasterelement"}}')
  delete Component.options._Ctor
}
